import { ReactElement } from 'react';

import styles from './FormItem.module.css';

/* ============================================ Local Types ============================================ */
type TFormItem = (props: {
  className?: string;
  contentClassName?: string;
  label?: string;
  isRequired?: boolean;
  children: ReactElement | Array<ReactElement>;
}) => ReactElement;

/* ============================================ Main Component ============================================ */
const FormItem: TFormItem = ({ className = '', contentClassName = '', label, isRequired, children }) => {
  return (
    <div className={className}>
      {label && <div className={styles['label']}>{`${label}${isRequired ? '*' : ''}:`}</div>}
      <div className={`${styles['content']} ${contentClassName}`}>{children}</div>
    </div>
  );
};

export default FormItem;
